import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { AuthService } from '../../../core/services/auth.service'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { MessageDialogComponent } from '../message-dialog/message-dialog.component'
import { MatCheckboxModule } from '@angular/material/checkbox'

@Component({
  selector: 'comingsoon-component',
  templateUrl: 'comingsoon.component.html',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    CommonModule,
    RouterModule,
  ],
  styleUrl: './comingsoon.component.css'
})
export class ComingSoonComponent implements OnInit, OnDestroy {
  titleRow1: string = "PRÓXIMAMENTE..."
  displayedTitleRow1: string = ''
  private typingTimeout: any
  private currentLetterIndex: number = 0

  constructor(
    public service: AuthService,
    private dialog: MatDialog
  ){}

  ngOnInit(): void {
    this.startTypingEffect()
  }

  ngOnDestroy(): void {
    clearTimeout(this.typingTimeout)
  }

  startTypingEffect() {
    this.typeLetter()
  }

  typeLetter() {
    if (this.currentLetterIndex < this.titleRow1.length) {
      this.displayedTitleRow1 += this.titleRow1[this.currentLetterIndex]
      this.currentLetterIndex++
      this.typingTimeout = setTimeout(() => this.typeLetter(), 200)
    } else {
      this.typingTimeout = setTimeout(() => this.clearText(), 1000);
    }
  }

  clearText() {
    this.displayedTitleRow1 = ''
    this.currentLetterIndex = 0
    this.typingTimeout = setTimeout(() => this.typeLetter(), 500)
  }

  register(){
    if (!this.service.newsletterForm.valid) return
    this.service.inscribirse()
    .subscribe(data =>{
      this.openDialog(data as string)
      this.service.newsletterForm.reset()
    })
  }

  openDialog(message: string){
    this.dialog.open(MessageDialogComponent, {
      data: { message }
    })
  }
}